<template>
  <v-select
    v-model="inputedValue"
    :items="ranks"
    label="対象KWランク"
    return-object
    style='max-width: 130px;'
    class="pt-2 mr-3"
    :rules="[presenceValidation]"
  />
</template>

<script>
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  mixins: [formValidationUtils],
  props: {
    value: {
      type: String
    }
  },
  computed: {
    inputedValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  data: function () {
    return {
      ranks: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j']
    }
  }
}
</script>
